import { Component, input } from "@angular/core";
import { CommonModule } from "@angular/common";

/**
 * Thin animated "chasing" border shown at the top of a page while cached data
 * is being refreshed from the server in the background (data is already visible).
 */
@Component({
  selector: "app-background-refresh-indicator",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./background-refresh-indicator.component.html",
  styleUrl: "./background-refresh-indicator.component.scss"
})
export class BackgroundRefreshIndicatorComponent {
  active = input<boolean>(false);
}
